var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.4 45.09"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".10_svg__cls-2{fill:#242424}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10_svg__\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10_svg__\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 1.85v9.72H15.43V1.85H28M29.82 0H13.58v13.42h16.24V0z",
    fill: "#00b468"
  }), /*#__PURE__*/React.createElement("path", {
    className: "10_svg__cls-2",
    d: "M25.29 35.91v7.18h-7.18v-7.18h7.18m2-2H16.11v11.18h11.18V33.91z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#242424",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    fill: "none",
    d: "M5.59 32.22V21.04h32.22v11.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "10_svg__cls-2",
    d: "M9.18 35.91v7.18H2v-7.18h7.18m2-2H0v11.18h11.18V33.91zM41.4 35.91v7.18h-7.18v-7.18h7.18m2-2H32.22v11.18H43.4V33.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#242424",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M21.7 14.99v16.67"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0My40IDQ1LjA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwYjQ2ODt9LmNscy0ye2ZpbGw6IzI0MjQyNDt9LmNscy0ze2ZpbGw6bm9uZTt9LmNscy0zLC5jbHMtNHtzdHJva2U6IzI0MjQyNDtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6MnB4O30uY2xzLTR7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+MTA8L3RpdGxlPjxnIGlkPSLlm77lsYJfMiIgZGF0YS1uYW1lPSLlm77lsYIgMiI+PGcgaWQ9IuWbvuWxgl8xLTIiIGRhdGEtbmFtZT0i5Zu+5bGCIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI4LDEuODV2OS43MkgxNS40M1YxLjg1SDI4TTI5LjgyLDBIMTMuNThWMTMuNDJIMjkuODJWMFoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik0yNS4yOSwzNS45MXY3LjE4SDE4LjExVjM1LjkxaDcuMThtMi0ySDE2LjExVjQ1LjA5SDI3LjI5VjMzLjkxWiIvPjxwb2x5bGluZSBjbGFzcz0iY2xzLTMiIHBvaW50cz0iNS41OSAzMi4yMiA1LjU5IDIxLjA0IDM3LjgxIDIxLjA0IDM3LjgxIDMyLjIyIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNOS4xOCwzNS45MXY3LjE4SDJWMzUuOTFIOS4xOG0yLTJIMFY0NS4wOUgxMS4xOFYzMy45MVoiLz48cGF0aCBjbGFzcz0iY2xzLTIiIGQ9Ik00MS40LDM1LjkxdjcuMThIMzQuMjJWMzUuOTFINDEuNG0yLTJIMzIuMjJWNDUuMDlINDMuNFYzMy45MVoiLz48bGluZSBjbGFzcz0iY2xzLTQiIHgxPSIyMS43IiB5MT0iMTQuOTkiIHgyPSIyMS43IiB5Mj0iMzEuNjYiLz48L2c+PC9nPjwvc3ZnPg==";
export { Svg10 as ReactComponent };